import { useMemo } from 'react';
import { useQuery } from 'urql';

import {
  TAXONOMY_LATEST_VERSION_QUERY,
  TAXONOMY_VERSIONS_QUERY,
  type TaxonomyType,
  type TaxonomyVersionsQuery,
} from '@revelio/data-access';

const EMPTY_VERSIONS: TaxonomyVersionsQuery['taxonomyVersions']['versions'] =
  [];

export const useTaxonomyVersions = ({
  taxonomyType,
  pause = false,
}: {
  taxonomyType: TaxonomyType;
  pause?: boolean;
}) => {
  const variables = useMemo(
    () => ({
      taxonomyType,
    }),
    [taxonomyType]
  );
  const context = useMemo(
    () => ({
      priority: 'low' as const,
      skipGlobalErrorHandling: true,
    }),
    []
  );
  const [{ data, fetching, error }] = useQuery({
    query: TAXONOMY_VERSIONS_QUERY,
    variables,
    pause,
    requestPolicy: 'cache-first',
    context,
  });

  return {
    versions: data?.taxonomyVersions.versions ?? EMPTY_VERSIONS,
    hasData: data?.taxonomyVersions !== undefined,
    fetching,
    error,
  };
};

export const useTaxonomyLatestVersion = ({
  taxonomyType,
  pause = false,
}: {
  taxonomyType: TaxonomyType;
  pause?: boolean;
}) => {
  const variables = useMemo(
    () => ({
      taxonomyType,
    }),
    [taxonomyType]
  );
  const context = useMemo(
    () => ({
      priority: 'low' as const,
      skipGlobalErrorHandling: true,
    }),
    []
  );
  const [{ data, fetching, error }] = useQuery({
    query: TAXONOMY_LATEST_VERSION_QUERY,
    variables,
    pause,
    requestPolicy: 'cache-first',
    context,
  });

  return {
    version: data?.taxonomyLatestVersion.version,
    hasData: data?.taxonomyLatestVersion !== undefined,
    fetching,
    error,
  };
};
